module.exports = __webpack_public_path__ + "static/pm-abiy-3-bc90b9c87d39861517609c9b863e6a50.jpg";